
import AdminNavbar from './AdminNavbar';
import WhatsAppButton from './WhatsAppButton';
import { useBlockNavigation } from '@/hooks/useBlockNavigation';
import { useEffect } from 'react';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  // Bloquear navegación en todas las pantallas del admin de manera más selectiva
  useBlockNavigation();

  // Deshabilitar el comportamiento de beforeunload en interacciones internas
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      // Si el click es en un elemento interno del admin, no mostrar confirmación
      const target = event.target as HTMLElement;
      if (target && target.closest('[data-admin-internal]')) {
        // Temporalmente deshabilitar beforeunload para clics internos
        const originalHandler = window.onbeforeunload;
        window.onbeforeunload = null;
        
        setTimeout(() => {
          window.onbeforeunload = originalHandler;
        }, 100);
      }
    };

    document.addEventListener('click', handleClick);
    
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" data-admin-internal>
      <AdminNavbar />
      <main className="flex-1 pt-16" data-admin-internal>
        {children}
      </main>
      <WhatsAppButton />
    </div>
  );
};

export default AdminLayout;
